import React, { useEffect, useState } from "react";
import { CancelOrder, CancelOrderByAdmin, createdPass, PostOrderAdmin } from "../../../../services/OrderService";
import User, { UserRole } from "../../../../models/User";
import { PostUserAdmin } from "../../../../services/UserService";
import { ActiveType } from "../../../../models/Login";
import useAlertDialog from "../../../hooks/useAlertDialog";
import { AlertType } from "../../../hooks/common/useAttachAlertDialog";

export default function useAddUserAdmin(props: { reload?: () => void }) {
	const { openAlertDialog } = useAlertDialog();
	const addUserAd = async (
		name: string,
		email: string,
		phone: string,
		pass: string,
		rePass: string,
		selectedCountryCode: string,
		type: string
	) => {
		try {
			await PostUserAdmin(name, email, phone, pass, rePass, selectedCountryCode, type);
			openAlertDialog?.(AlertType.Success, "Add Successfully!", () => {
				props.reload?.();
			});
		} catch (err: any) {
			console.error(err);
			openAlertDialog?.(AlertType.Fail, err?.response.data?.message || "Fail!");
		}
	};

	return {
		addUserAd,
	};
}
